import { render, staticRenderFns } from "./select-teaching.vue?vue&type=template&id=eaf9f006&scoped=true"
import script from "./select-teaching.vue?vue&type=script&lang=js"
export * from "./select-teaching.vue?vue&type=script&lang=js"
import style0 from "./select-teaching.vue?vue&type=style&index=0&id=eaf9f006&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf9f006",
  null
  
)

export default component.exports